import { Box, Image } from '@chakra-ui/react'
import React from 'react'

const PhoneFrameWrapper = ({ children }) => {
  return (
    <Box height="564px" width="260px" position="relative">
      <Image
        height="100%"
        width="100%"
        src={`${process.env.REACT_APP_CDN_IMAGE}/https://housi-images.s3.amazonaws.com/site/landing-pages/appspace/iphone-frame.png`}
      />
      <Box position="absolute" top="85px">
        {children}
      </Box>
    </Box>
  )
}

export default PhoneFrameWrapper
